import { createTranslations } from '@npco/utils-translations'

export const setupFlowPaymentsStageTranslations = createTranslations({
  badge: 'Payments',
  title: 'You’re ready to start accepting card payments.',
  description:
    'Zeller gives you more ways to get paid. Use Zeller Terminal, Invoices, Virtual Terminal, and Tap to Pay in the Zeller App.',
  point1: 'Zero-cost payment acceptance with built-in surcharging.',
  point2: 'Email and SMS receipts, tipping, and customisable screensavers.',
  point3: 'Integrate Zeller Terminal with 600+ point-of-sale platforms.',
  point4: 'Fast settlements, 365 days a year.',
  point5: 'Accept contactless payments with your iPhone.',
  animationDataFilenameSmall: 'setup-flow-payments-small',
  animationDataFilenameMedium: 'setup-flow-payments-medium',
  animationDataFilenameLarge: 'setup-flow-payments-large',
})
